/*
 * Resolution
 *
 * Author: Anthony LEFOYE
 * Copyright (c) 2022-2023 Prodeo - All Rights Reserved
 */

const API_NAMES = Object.freeze( {
  AUTH_PASSWORD_CHANGE: 'api/auth/password/change/',
  AUTH_PASSWORD_CODE: 'api/auth/password/code/',
  AUTH_FM_IS_CONNECT: 'api/auth/is-flashmeeting-connect/',
  AUTH_IS_FM_USER_SIGN_IN: 'api/auth/is-fm-user-sign-in/',
  AUTH_IS_SIGN_IN_WEB: 'api/auth/is-sign-in/web/',
  AUTH_SIGN_IN: 'api/auth/sign-in/',
  AUTH_PASSWORD_VERIFY: 'api/auth/password/verify/',
  BOARD_CONTENT: 'api/board/content/',
  BOARD_ARCHIVED_CONTENT: 'api/board/content/archived/',
  RIGHTS: 'api/rights/',
  RP_FOR_USER: 'api/rp/for_user/',
  RP_USERS_AUTH: 'api/rp/users/auth/',
  RP: 'api/rp/',
  RP_BY_ID: 'api/rp/by_id/',
  RP_DESCRIPTION: 'api/rp/description/',
  RP_SECURING_ACTION: 'api/rp/securing_actions/',
  RP_CAUSES: 'api/rp/causes/',
  RP_ACTIONS: 'api/rp/actions/',
  RP_CAPITALISING_ACTION: 'api/rp/capitalisation_actions/',
  RP_NOTES: 'api/rp/notes/',
  RP_CLOSE: 'api/rp/close/',
  RP_REOPEN: 'api/rp/reopen/',
  RP_USERS: 'api/rp/users/',
  RP_DOWNLOAD_ISHIKAWA: '/api/print/download/ishikawa/',
  RP_DOWNLOAD_REPORT: 'api/print/download/report/',
  RP_INDICATORS: 'api/indicators/',
  RP_DOCUMENTS: 'api/rp/documents/',
  RP_STICKY_NOTES: 'api/sticky_notes/',
  TOOL_6W: 'api/tool/6W/',
  TOOL_CONTEXT: 'api/tool/context/',
  TOOL_IS_ISNOT: '/api/tool/is_is_not/',
  TOOL_5WHY: '/api/tool/5why/',
  TOOL_PRIORITY_MATRIX: '/api/tool/priority_matrix/',
  TOOL_QRQC_FACTOR: '/api/tool/qrqc_factor/',
  TOOL_QRQC_DETAIL: '/api/tool/qrqc_detail/',
  CAUSES: 'api/causes/',
  SECURING_ACTION: 'api/securing_actions/',
  ACTIONS: 'api/actions/',
  ACTIONS_USERS: 'api/actions/users/',
  ACTIONS_NOTES: 'api/actions/notes/',
  DOCUMENTS: 'api/documents/',
  GLOBAL_INDICATORS_DURATION_RP: 'api/indicators/open_duration_rp/',
  GLOBAL_INDICATORS_RP_PROGRESSIONS: 'api/indicators/rp_progressions/',
  GLOBAL_INDICATORS_LATE_ACTIONS: 'api/indicators/late_duration_actions/',
  GLOBAL_INDICATORS_LATE_ACTIONS_COUNTER: 'api/indicators/late_action_counter/',
  GLOBAL_INDICATORS_ACTIONS_PARETO: 'api/indicators/pareto_planned_actions/',
  GLOBAL_INDICATORS_RECURRING_RP_COUNTER: 'api/indicators/recurring_rp_counter/',
  GLOBAL_INDICATORS_MEDIAN_PROGRESS_RP: 'api/indicators/median_time_rp_progress/',
  GLOBAL_INDICATORS_MEDIAN_SECURING_ACTIONS: 'api/indicators/securing_median_time/',
  SERVICES: '/api/services/',
  USERS: '/api/users/',
  USERS_SETTINGS: '/api/users/settings/',
  IMPACT_STUDIES: '/api/impact_studies/',
  SETTING: 'api/setting/',
  RESET_SETTING: '/api/setting/reset/',
  MY_SITES: 'api/site/my-sites/'
} );

const get_api = ( api_name, ...args ) => {
  if ( args && args != '' ) {
    args.forEach( ( arg ) => {
      api_name = api_name + arg + '/';
    } );
  }
  return api_name;
};

export default { API_NAMES, get_api };